import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CustomAccordionComponent} from './custom-accordion.component';
import {CmsConfig, ConfigModule, I18nModule} from "@spartacus/core";
import {CustomItemAccordionModule} from "./custom-item-accordion/custom-item-accordion.module";

@NgModule({
  declarations: [CustomAccordionComponent],
  exports: [CustomAccordionComponent],
  imports: [
    CommonModule,
    I18nModule,
    CustomItemAccordionModule,
    ConfigModule.withConfig({
      cmsComponents: {
        AccordionComponent: {
          component: CustomAccordionComponent,
        },
      },
    } as CmsConfig),
  ]
})
export class CustomAccordionModule { }
